import getMlsThreshold from '../get-mls-threshold';

/**
 * Calculate the MLS amount based on scale and income.
 *
 * NOTE: The number of dependants can effect the amount paid if more than 1 dependent.
 * We are assuming they have less than 2 dependents and show a disclaimer advising them of this.
 * Check the blame history to see this logic if you need it in future.
 *
 * @param {object} customer - Object of customer.
 * @param {string} customer.scale - Customer scale.
 * @param {number} customer.income - Customer income.
 */
// @ts-expect-error - Automatic, Please fix when editing this file
const calculateMls = ({ scale, income }) => {
  const { rate } = getMlsThreshold({ income, scale });
  return (income * rate) / 100;
};

export default calculateMls;
